import React from 'react'
import { Button, Form, Spin } from 'antd'
import _get from 'lodash/get'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link, Redirect } from 'react-router-dom'
import OrderItemModal from '~/App/components/OrderItemModal'
import ProductExtraSale from '~/App/components/ProductExtraSale'
import OrderSteps from '~/App/components/OrderSteps'
import addOrderItemMutation from '~/App/graphql/mutations/addOrderItem.gql'
import removeOrderItemMutation from '~/App/graphql/mutations/removeOrderItem.gql'
import orderQuery from '~/App/graphql/queries/order.gql'
import OrderItemsCart from '~/App/components/OrderItemsCart'
import localeGet from '~/App/utils/localeGet'
@inject('i18n')
@inject('router')
@Form.create()
@injectIntl
@graphql(removeOrderItemMutation, {
  name: 'removeOrderItemMutation'
})
@graphql(orderQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(addOrderItemMutation, {
  name: 'addOrderItem'
})
@observer
class RegistrationOrderEdit extends React.Component {
  state = {
    submitting: false
  }
  handleRemoveOrderItem = ({_id}) => {
    this.setState({submitting: true})
    const {history, removeOrderItemMutation, match: { params: { id } }} = this.props
    removeOrderItemMutation({
      variables: { _id }
    }).then(res => {
      history.push(`/orders/${id}/edit`)
    }).catch(e => {
      this.alertError(e)
      this.submitting = false
    })
  }
  handleAddOrderItem = async (orderItem) => {
    const { match: { params: { id } } } = this.props
    const { location, history } = this.props.router
    await this.props.addOrderItem({
      variables: {
        record: orderItem
      }, // TODO: writeQuery
      refetchQueries: [{ // can use updateQuery
        query: orderQuery,
        variables: {
          _id: id
        }
      }]
    })
    history.replace({
      ...location
    })
  }
  handleSelectProduct = (productId) => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      pdId: productId
    }
  }
  render () {
    const {
      data,
      i18n: { locale }
    } = this.props
    if (data.loading || this.state.submitting) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (!data.order) {
      return <div>Order not found...</div>
    }
    const order = _get(data, 'order')
    const status = _get(data, 'order.status')
    const event = _get(data, 'order.event')
    const amount = _get(data, 'order.amount')
    const registration = _get(data, 'order.registration')
    const { pdId } = this.props.router.location.query
    return status && status === 'paid'
      ? <Redirect to={`/orders/${order._id}`} /> : <div>
        <Form onSubmit={this.handleSaveRegistration} className="EventRegisterPage">
          <div className="innerEventRegisterPage" >
            <div className="dividedBox">
              <div className="registrationTopTitle">
                {localeGet(data, 'order.event.name', locale)}
              </div>
              <OrderSteps step="shop" />
            </div>
            <div className="dividedBox">
              <h1><FormattedMessage id="app.extraItems" /></h1>
              <span><FormattedMessage id="app.orderCode" /> : {order.code}</span>
              {event.extraProductCount > 0 && <div className="orderedItemsPreview dividedBox">
                <h1><FormattedMessage id="app.extraItems" /></h1>
                <ProductExtraSale
                  registrationId={registration._id}
                  onAddOrderItem={this.handleAddOrderItem}/>
                {order.items.length > 0 &&
                  <OrderItemsCart
                    event={event}
                    orderItems={order.items}
                    submitting={this.state.submitting}
                    locale={locale}
                    handleRemoveOrderItem={this.handleRemoveOrderItem} />}
              </div>}
              <div style={{ padding: '8px', textAlign: 'right' }}>
              Total: {_get(amount, 'discounted')} THB
              </div>
              <div style={{ padding: '8px', textAlign: 'right' }}>
                <Link to={`/orders/${order._id}/pay`}>
                  <Button type="primary">
                    <FormattedMessage id="app.pay" defaultMessage="Pay" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Form>
        {!!pdId && pdId !== 'select' &&
        <OrderItemModal
          event={event}
          registrationId={registration._id}
          masterId={order._id}
          masterType="Order"
          productId={pdId}
          onAddOrderItem={this.handleAddOrderItem }
        />
        }
      </div>
  }
}

export default RegistrationOrderEdit



// WEBPACK FOOTER //
// ./src/App/pages/RegistrationOrderEdit/RegistrationOrderEdit.js